/**
 * Whether the viewport is narrow enough for the sidebar to become a sheet.
 *
 * The registry's version starts as `undefined` and sets the real value from inside the
 * effect. That is a synchronous state write during commit, which the React Compiler rule
 * reports — and it also means the first paint always guesses "not mobile", so a phone
 * briefly renders the desktop sidebar. Reading `matchMedia` in the initialiser instead
 * answers correctly on the first render and leaves the effect with nothing to do but
 * subscribe.
 */
import * as React from 'react'

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
	const [isMobile, setIsMobile] = React.useState<boolean>(() =>
		typeof window === 'undefined' ? false : window.innerWidth < MOBILE_BREAKPOINT,
	)

	React.useEffect(() => {
		const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
		const onChange = () => setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
		mql.addEventListener('change', onChange)
		return () => mql.removeEventListener('change', onChange)
	}, [])

	return isMobile
}
